import React from 'react';
import { Box, InputLabel, TextField, createTheme, ThemeProvider, InputAdornment } from '@mui/material';
import { colors } from '../../common/pallette/colors';

const theme = createTheme({
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: 12
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    padding: '8px !important'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.black.dark,
                    },
                    '& .Mui-disabled': {
                        cursor: 'not-allowed'
                    },
                    fontSize: '13px',
                },
            }
        }
    }
})

const CustomCurrencyTextField = (props: any) => {
    const { label, value, manageChange, errorMessage, isError, isReadOnly } = props;
    return(
        <ThemeProvider theme={theme}>
            <Box>
                <InputLabel sx={{ color: colors.black.dark }}>{label}</InputLabel>
                <TextField
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            ¥
                        </InputAdornment>
                    )
                }}
                 label='' value={value ? value : 0}
                 onChange={(e:any) => {manageChange(parseInt(e.target.value))}} 
                 error={isError}
                 disabled={isReadOnly}
                 helperText={isError ? errorMessage : ''}
                 />
            </Box>
        </ThemeProvider>
    )
}

export default CustomCurrencyTextField;